import { SynergridConfigurationInfo } from '@/models'

export interface ConfigurationInfoState {
  configurationInfo: SynergridConfigurationInfo | null
}

export const InitialState: ConfigurationInfoState = {
  configurationInfo: null
}
